import { render, staticRenderFns } from "./AddToCartGroupProduct.vue?vue&type=template&id=28d511a9&scoped=true&"
import script from "./AddToCartGroupProduct.vue?vue&type=script&lang=js&"
export * from "./AddToCartGroupProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartGroupProduct.vue?vue&type=style&index=0&id=28d511a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d511a9",
  null
  
)

export default component.exports